<template>
	<div>
		<h5 class="info-text">Настрой что показывать</h5>
		<div>
			<template v-for="element in value">
				<div class="row" v-if="element.elementType == 'switcher'" :data-element="element" :key="element.elementGetParamMap">
					<label class="col-form-label col-md-3">{{ element.placeholder }}</label>
					<div class="form-group col-md-9">
						<base-switch
							v-model="element.element_model"
							type="primary"
							:on-text="element.label_on"
							:off-text="element.label_off"
						></base-switch>
					</div>
				</div>
			</template>
		</div>		
	</div>
</template>
<script>
import { BaseSwitch } from 'src/components/index';
export default {
	components: { 
		BaseSwitch, 
	},
	props: {
		value: Array
	},
  	data() {
		return {
			model: {
				firstName: '',
				lastName: '',
				email: '',
				phone: '',
				address: ''
			},
			modelValidations: {
				firstName: {
				required: true,
				min: 5
				},
				lastName: {
				required: true,
				min: 5
				},
				email: {
				required: true,
				email: true
				},
				phone: {
				required: true,
				numeric: true
				}
			}
		};
  	},
	methods: {
		getError(fieldName) {
			return this.errors.first(fieldName);
		},
		validate() {
			return this.$validator.validateAll().then(res => {
				this.$emit('on-validated', res, this.model);
				return res;
			});
		}
	}
};
</script>
<style scoped>

</style>
